/**
 * useAccountTimezoneEntry — la ligne « Fuseau horaire » d'un écran de réglages du design system :
 * la ville du compte en valeur, et le geste qui ouvre l'écran `account-timezone`.
 *
 * Lecteurs : le portail Abonnement du parent (section « Compte ») et la ligne d'accès des
 * réglages élève et tuteur, restés legacy (exception datée, `ports/TRANSITION.md`).
 */
import { useCallback } from "react"
import { useNavigation } from "@react-navigation/native"
import { useSelector } from "react-redux"

import { accountTimezoneEntryViewModel } from "../../view-models/account/Timezone/accountTimezoneViewModel"

/** La route de l'écran, déclarée dans `navigationScreens.js` pour les piles principale et parent. */
export const ACCOUNT_TIMEZONE_ROUTE = "account-timezone"

export function useAccountTimezoneEntry() {
    const { cityLabel } = useSelector(accountTimezoneEntryViewModel)
    const navigation = useNavigation<{ push: (name: string) => void }>()
    const onOpenTimezone = useCallback(() => navigation.push(ACCOUNT_TIMEZONE_ROUTE), [navigation])

    return { timezoneCity: cityLabel, onOpenTimezone }
}
